/*
 * @Author: Zhouqi
 * @Date: 2025-12-19 17:30:07
 * @LastEditors: Zhouqi
 * @LastEditTime: 2025-12-22 14:33:28
 */
import { ApiResponse } from '@/services';
import request from '@/utils/request';

export interface VideoDataItem {
  type: string;
  title: string;
  desc: string;
  fileUrl: string;
  createTime: number;
  renaming: boolean;
  duration: number;
  id: number;
  cover: string;
  taskType: number;
  extendInfo: string;
  customType: string;
}

/**
 * 查询视频列表
 * @param id 片段id
 * @returns
 */
export const getVideoList = async <T>(data: {
  // 1-文件夹，2-图片，3-视频，4-字体,5-音频,6- 音色音频 ，7- zip 文件,8-文本
  type: number;
  sourceType: number;
  pageNum: number;
  pageSize: number;
}): Promise<ApiResponse<T>> => {
  const res = await request('/api/rest/dlt/asset/query', {
    method: 'POST',
    data,
  });
  return res;
};

/**
 * 删除视频
 * @param data
 * @returns
 */
export const deleteVideo = async <T>(
  ids: Array<string | number>,
): Promise<ApiResponse<T>> => {
  const res = await request('/api/rest/dlt/asset/del', {
    method: 'POST',
    data: {
      ids,
    },
  });
  return res;
};

/**
 * 重命名视频
 */
export const renameVideo = async <T>(params: {
  id: number;
  title: string;
}): Promise<ApiResponse<T>> => {
  const res = await request('/api/rest/dlt/asset/update', {
    method: 'POST',
    data: params,
  });
  return res;
};
